import React, { useState } from "react";
import { Button, Table } from "react-bootstrap";

const ParameterTable = ({
    data,
    onRemove,
    onEdit,
    showTable,
    hideValue = false,
    allowEdit = false,
}) => {
    const [editingParam, setEditingParam] = useState(null);
    const [editParameterName, setEditParameterName] = useState('');
    const [editingValue, setEditingValue] = useState('');

    if (!showTable || data.length === 0) {
        return null;
    }

    const PROTECTED_KEY = "content-type";

    const isProtectedParam = (p) => p.toLowerCase() === PROTECTED_KEY;
    const hasType = data.some(item => item.type !== undefined);

    const startEdit = (param, value) => {
        setEditingParam(param);
        setEditParameterName(param);
        setEditingValue(formatValue(value));
    };

    const saveEdit = () => {
        if (onEdit) {
            onEdit(editingParam, editParameterName, editingValue);
        }
        cancelEdit();
    };

    const cancelEdit = () => {
        setEditingParam(null);
        setEditParameterName('');
        setEditingValue('');
    };

    const handleRemoveClick = (param) => {
        if (!isProtectedParam(param)) {
            onRemove(param);
        }
    };

    const formatValue = (val) => {
        if (val === null || val === undefined) return '';
        if (typeof val === 'object') return JSON.stringify(val);
        return String(val);
    };

    return (
        <div className="scrollable-table" style={{ maxHeight: '200px', overflowY: 'auto', maxWidth: '800px' }}>
            <Table striped bordered size="sm" style={{ tableLayout: 'fixed' }}>
                <thead>
                    <tr>
                        {hasType && <th style={{ width: '30%' }}>Type</th>}
                        <th style={{ width: hasType ? '30%' : '40%' }}>Parameter</th>
                        {!hideValue && <th style={{ width: hasType ? '30%' : '40%' }}>Value</th>}
                        <th style={{ width: '20%' }}>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item, index) => {
                        const isEditing = allowEdit && editingParam === item.parameter;
                        const protectedRow = isProtectedParam(item.parameter);
                        return (
                            <tr key={index}>
                                {hasType && <td>{formatValue(item.type)}</td>}
                                <td>
                                    {isEditing ? (
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={editParameterName}
                                            onChange={(e) => setEditParameterName(e.target.value)}
                                            disabled={protectedRow} 
                                        />
                                    ) : (
                                        formatValue(item.parameter)
                                    )}
                                </td>
                                {!hideValue && (
                                    <td>
                                        {isEditing ? (
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={editingValue}
                                                onChange={(e) => setEditingValue(e.target.value)}
                                                disabled={protectedRow}
                                            />
                                        ) : (
                                            formatValue(item.value)
                                        )}
                                    </td>
                                )}
                                <td>
                                    {isEditing ? (
                                        <>
                                            <Button
                                                variant="success"
                                                size="sm"
                                                className="me-2"
                                                onClick={saveEdit}
                                                disabled={protectedRow}
                                            >
                                                Save
                                            </Button>
                                            <Button
                                                variant="secondary"
                                                size="sm"
                                                onClick={cancelEdit}
                                            >
                                                Cancel
                                            </Button>
                                        </>
                                    ) : (
                                        <>
                                            {allowEdit && !protectedRow && (
                                                <Button
                                                    variant="warning"
                                                    size="sm"
                                                    className="me-2"
                                                    onClick={() => startEdit(item.parameter, item.value)}
                                                >
                                                    <i className="fa fa-edit"></i>
                                                </Button>
                                            )}

                                            {!protectedRow && (
                                                <Button
                                                    variant="danger"
                                                    size="sm"
                                                    onClick={() => handleRemoveClick(item.parameter)}
                                                >
                                                    <i className="fa fa-minus"></i>
                                                </Button>
                                            )}

                                            {protectedRow && (
                                                <span style={{ color: "gray", fontSize: "12px" }}>
                                                    Protected
                                                </span>
                                            )}
                                        </>
                                    )}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        </div>
    );
};

export default ParameterTable;
